<template>
  <div id="dashboard-content">
    <InvestmentReports v-if="viewInvstRptHome" />
    <InvestmentReportDetails
      :footerurl="reporterDetailsPageURL"
      :id="id"
      v-if="viewInvstRptDetails"
    />
    <ImpactReports v-if="viewImpctRptHome" />
    <ImpactReportDetails
      v-if="viewImpctRptDetails"
      :footerurl="reporterDetailsPageURL"
      :id="id"
    />
    <StoryReports v-if="viewStrRptHome" />
    <StoryReportDetails
      v-if="viewStrRptDetails"
      :footerurl="reporterDetailsPageURL"
      :id="id"
    />

    <template v-if="pageNotFound">
      <h5>
        Recovery Report not found
      </h5>
      <div id="block-report-content">
        The requested <b>{{ this.errorMessage }} </b> recovery report could not
        be found.
      </div>

      <b-button class="mt-4" variant="outline-primary" :href="`/recovery`"
        >Go To NIH Recovery Act Archive</b-button
      >
    </template>
  </div>
</template>
<script>
import InvestmentReports from "@/components/recovery/InvestmentReports";
import InvestmentReportDetails from "@/components/recovery/InvestmentReportDetails";
import ImpactReports from "@/components/recovery/ImpactReports";
import ImpactReportDetails from "@/components/recovery/ImpactReportDetails";
import StoryReports from "@/components/recovery/StoryReports";
import StoryReportDetails from "@/components/recovery/StoryReportDetails";
import { BaseURL, GET_SETTING_SUB_PATH, RPTR_BASE_PROP_NAME, RECOVERY_ID_MAX } from "@/shared/config.js";

export default {
  name: "RecoveryReportHome",
  components: {
    InvestmentReports,
    InvestmentReportDetails,
    ImpactReports,
    ImpactReportDetails,
    StoryReports,
    StoryReportDetails
  },
  data() {
    return {
      viewInvstRptHome: false,
      viewInvstRptDetails: false,
      viewImpctRptHome: false,
      viewImpctRptDetails: false,
      viewStrRptHome: false,
      viewStrRptDetails: false,
      reporterDetailsPageURL: '',
      pageNotFound: false,
      errorMessage: "",
      id: Number
    };
  },
  mounted() {
    this.getUriParams();
    this.getReporterDetailsUrl();
  },
  methods: {
    /**
     * Intercept URI param and load appropriate component
     *
     */
    getUriParams() {
      //valid reportName through url get param
      const validParam = ["investment", "impact", "story"];
      //Retrive current url
      const uri = window.location.search.substring(1);
      //extract uri parameters
      const params = new URLSearchParams(uri);
      //retrive reportName
      let reportName = params.get("reportName");

      // trim and lower the reportName param
      if (reportName) {
        reportName = reportName.toLowerCase().trim();
      }
      // Validate reportName Param
      if (!validParam.includes(reportName)) {
        // Dsiplay Error on the screen
        console.log("No report name found in URL");
        this.pageNotFound = true;
        return;
      }
      //retrive id
      const paramId = params.get("id");

      // Validate the ID
      if (
        paramId &&
        !(
          !isNaN(parseInt(paramId)) &&
          paramId >= 1 &&
          paramId <= RECOVERY_ID_MAX
        )
      ) {
        // Dsiplay Error on the screen

        this.pageNotFound = true;
        this.errorMessage = reportName;
        return;
      }

      this.id = parseInt(paramId);

      if (reportName === "investment") {
        this.viewInvstRptHome = true;
      }
      if (reportName === "investment" && this.id) {
        this.viewInvstRptDetails = true;
        this.viewInvstRptHome = false;
      }
      if (reportName === "impact") {
        this.viewImpctRptHome = true;
      }
      if (reportName === "impact" && this.id) {
        this.viewImpctRptDetails = true;
        this.viewImpctRptHome = false;
      }
      if (reportName === "story") {
        this.viewStrRptHome = true;
      }
      if (reportName === "story" && this.id) {
        this.viewStrRptDetails = true;
        this.viewStrRptHome = false;
      }
    },

    getReporterDetailsUrl() {
      var xhr;

      xhr = new XMLHttpRequest();
      var url,
        requestType = 'GET',
        $this = this;
      url = BaseURL + GET_SETTING_SUB_PATH + RPTR_BASE_PROP_NAME;

      xhr.open(requestType, url, true);

      xhr.onload = function () {
        
        if (xhr.status === 200) {
          $this.reporterDetailsPageURL = xhr.responseText + '/project-details/';
        }
      };
      xhr.send();

    }
  }
};
</script>
